import React, { useState } from "react";

import AnimatedTuneIcon from "@components/shared/Icons/AnimatedTune";
import Icon from "@components/shared/Icons/Icon";
import Typography from "@components/shared/Typography";

import { useTranslation } from "@lib/i18n";
import { useOpenFinanceWidget } from "@hooks/useOpenFinanceWidget";

const FinanceWidgetButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  const openFinanceWidget = useOpenFinanceWidget();

  return (
    <button
      aria-label={t("price.financeWidgetText")}
      className="flex items-center outline-none cursor-pointer shrink grow-0 basis-0"
      data-id="finance-icon-container"
      onClick={openFinanceWidget}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon
        className="size-12 text-white"
        icon={<AnimatedTuneIcon externalHovered={isHovered} />}
      />
      <Typography className="text-xs underline text-left uppercase text-white font-bold tracking-wide cursor-pointer hidden pl-3 lg:block">
        {t("price.financeWidgetText")}
      </Typography>
    </button>
  );
};

export default FinanceWidgetButton;
